import React from "react";
import PasswordResetComponent from "../../Common/PasswordResetComponent";

const PasswordReset = () => <PasswordResetComponent
  passwordPath={"/vendor/new-password"}
/>;

export default PasswordReset;
